// EP-135 Tier 3 — Customer-facing meeting + ballot strings (TH).
// EP-135 Tier 4 — Customer-side read-only minutes (certified only).
export default {
  title: 'การประชุม',
  empty_title: 'ยังไม่มีการประชุม',
  empty_body:
    'เมื่อผู้ดูแลจัดการประชุมและเพิ่มคุณเป็นผู้เข้าร่วม (หรือระบุให้คุณเป็นผู้รับมอบฉันทะ) รายการจะปรากฏที่นี่',
  call_n: 'การประชุมครั้งที่ {{n}}',
  status: {
    draft: 'ร่าง',
    noticed: 'ออกหนังสือเชิญแล้ว',
    in_progress: 'กำลังดำเนินการ',
    voting_closed: 'ปิดรับคะแนนแล้ว',
    closed: 'ปิดการประชุม',
    certified: 'รับรองแล้ว',
  },
  proxy_role_only: 'คุณลงทะเบียนเป็นผู้รับมอบฉันทะ',
  proxy_for_one: 'รับมอบฉันทะจาก {{name}}',
  proxy_for_other: 'รับมอบฉันทะจากเจ้าของ {{count}} ท่าน',
  join_meeting: 'เข้าร่วมการประชุมออนไลน์',
  your_weight: 'น้ำหนักคะแนนของคุณ: {{weight}} ขององค์ประชุม',
  resolutions_title: 'มติที่ประชุม',
  resolutions_empty: 'ยังไม่มีมติที่ถูกเสนอสำหรับการประชุมนี้',
  resolution_seq: 'มติที่ {{seq}}',
  secret_ballot: 'ลงคะแนนลับ',
  you_voted: 'คุณลงคะแนน: {{choice}}',
  cast_ballot: 'ลงคะแนน',
  change_ballot: 'เปลี่ยนคะแนน',
  cast_for: 'ลงคะแนนในนาม',
  attendee_self: 'ตัวเอง',
  attendee_proxy: 'รับมอบฉันทะจาก {{name}}',
  your_choice: 'ตัวเลือกของคุณ',
  submit_ballot: 'ส่งคะแนน',
  choices: {
    for: 'เห็นด้วย',
    against: 'ไม่เห็นด้วย',
    abstain: 'งดออกเสียง',
  },
  minutes: {
    title: 'รายงานการประชุม',
    view_minutes: 'ดูรายงานการประชุมที่ลงนามแล้ว',
    pending_message:
      'รายงานการประชุมจะปรากฏที่นี่เมื่อประธานและเลขานุการได้ลงนามครบถ้วนแล้ว',
    not_yet_certified_title: 'ยังไม่ได้รับรองรายงานการประชุม',
    not_yet_certified_body:
      'รายงานการประชุมจะปรากฏที่นี่เมื่อการประชุมได้รับการรับรองครบถ้วนแล้ว',
    sections: {
      header: 'รายละเอียดการประชุม',
      attendance: 'ผู้เข้าร่วมประชุม',
      resolutions: 'มติที่ประชุม',
      certification: 'การลงนามรับรอง',
    },
    labels: {
      chair: 'ประธาน',
      secretary: 'เลขานุการ',
      meeting_type: 'ประเภท',
      call_number: 'ครั้งที่',
      agenda: 'ระเบียบวาระ',
      notice_lead_days: 'ระยะเวลาบอกกล่าว (วัน)',
      presence: 'สถานะ',
      weight: 'น้ำหนัก',
      secret: 'ลับ',
      total_cast: 'รวมคะแนน',
      outcome: 'ผลลัพธ์',
    },
  },
}
